import React from "react";
import {
  DisplayWall
} from "../../_metronic/_partials";

export function DWalls(props) {  
  return   <DisplayWall {...props} />;
}
